import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'declination',
  pure: false
})
export class DeclinationPipe implements PipeTransform {
  transform(number: number, args: any) {
    const numberOriginal = number;
    number = Math.abs(number);
    number %= 100;
    if (number >= 5 && number <= 20) {
      return numberOriginal + ' ' + args[2];
    }
    number %= 10;
    if (number === 1) {
      return numberOriginal + ' ' + args[0];
    }
    if (number >= 2 && number <= 4) {
      return numberOriginal + ' ' + args[1];
    }
    return numberOriginal + ' ' + args[2];
  }
}
